import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { checkAndUpdateTextDynamic } from '@angular/core/src/view/text';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'EmandateApp';
  autopolicyno:any;
  flag:any;
  constructor(private localstorage:LocalStorageService, private router:Router,private spinner: NgxSpinnerService,private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
  //  sessionStorage.setItem('p_policy_no_auto',"10000000044");
  //   sessionStorage.setItem('p_dob_auto',"01/01/1976");
  //  sessionStorage.setItem('p_mandate_type',"null");
    this.spinner.show(); 
    setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
    }, 3000);  
  }
  checkData(){
  if (this.activatedRoute.snapshot.queryParams['p_policy_no_auto']) {
    this.localstorage.set('p_policy_no_auto',this.activatedRoute.snapshot.queryParams['p_policy_no_auto']); 
    //  console.log("query param is",this.activatedRoute.snapshot.queryParams['p_policy_no_auto']);
    this.router.navigate(['/genericLink']);
  }
}

}
